import type { QuickStartSectionRef } from '../github.interface'
import { pickDefaultQuickStartLanguage } from '../utils/pickDefaultQuickStartLanguage'

import { quickStartNavUrlPathForSection } from './quickStartNavUrlPathForSection'
import { resolveLanguageList } from './utils/resolveLanguageList'
import { stripNumericPathPrefix } from './utils/stripNumericPathPrefix'

/**
 * Fallback resolver for multi-language sections accessed without a language suffix.
 * When a user visits e.g. `/quick-start/connect-microservices` (no language segment),
 * returns the canonical redirect path including the default language
 * (e.g. `connect-microservices/typescript`), or `null` if no match is found.
 */
export function resolveQuickStartSlugFallback(slug: string[], sections: QuickStartSectionRef[]): string | null {
  if (slug.length === 0) return null

  const joined = slug.join('/')

  const match = sections.find((s) => {
    const langs = resolveLanguageList(s)
    return langs.length > 1 && stripNumericPathPrefix(s.path) === joined
  })

  if (!match) return null

  const langs = resolveLanguageList(match)
  const priorityLang = pickDefaultQuickStartLanguage(langs)
  return quickStartNavUrlPathForSection(match, priorityLang)
}
